/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState} from "react";


import {Col, Row} from "react-bootstrap";

import {AiOutlineCheck} from "react-icons/all";


import MonitoryNoteCompartmentComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Compartments/Compartment";


import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";
import COMPARTMENT_INTERFACE from "@Services/Application/Interfaces/Vehicles/Compartment";



type MonitoryNoteCompartmentsProps = {
    EDITABLE?: boolean;
    compartmentModifyHandler?: any;
    compartmentClearHandler?: any;
    MONITORY_NOTE: MONITORY_NOTE_INTERFACE | null;
    MONITORY_NOTE_ACTION_TYPE?: "creation" | null;
    MONITORY_NOTE_DETAILED_STATUS?: boolean | null;
    MONITORY_NOTE_DETAILED_STATUS_HANDLER?: any;
    LOAD_CONTENT?: boolean;
};


export const MonitoryNoteCompartmentsComponent: React.FC<MonitoryNoteCompartmentsProps> = ({
    MONITORY_NOTE, MONITORY_NOTE_ACTION_TYPE = null,
    MONITORY_NOTE_DETAILED_STATUS, MONITORY_NOTE_DETAILED_STATUS_HANDLER,
    compartmentModifyHandler = null,
    compartmentClearHandler = null,
    EDITABLE = true, LOAD_CONTENT = true
}): JSX.Element | null => {


    if (!MONITORY_NOTE || !MONITORY_NOTE?.CompartmentsList) return null;


    if (!LOAD_CONTENT) return null;


    const CompartmentsList = Object.entries(MONITORY_NOTE?.CompartmentsList).map((compartment: any) => {

        return (
            <MonitoryNoteCompartmentComponent
                editable={EDITABLE}
                key={compartment}
                products={MONITORY_NOTE?.ProductsList}
                compartment={compartment}
                compartmentModifyHandler={compartmentModifyHandler}
                compartmentClearHandler={compartmentClearHandler}
            />
        );

    });

    return (
        <Col xs={12} className={"monitory-note-compartments-component monitory-note-compartments" + (!EDITABLE ? "" : "")}>
            <Row className={"monitory-note-compartments-content"}>

                <Col xs={12} className={"monitory-note-compartments-switcher"}>
                    <span className={"checkbox-button" + (!EDITABLE ? " inactive" : "")} onClick={() => EDITABLE ? MONITORY_NOTE_DETAILED_STATUS_HANDLER(!MONITORY_NOTE_DETAILED_STATUS) : null}>{MONITORY_NOTE_DETAILED_STATUS && <AiOutlineCheck />}</span>
                    <span>{`Plan załadunku`}</span>
                </Col>

                {!!MONITORY_NOTE_DETAILED_STATUS && CompartmentsList}

            </Row>
        </Col>
    );

};


export default MonitoryNoteCompartmentsComponent;
